import React from 'react';
import DefaultLayout from '../../layouts/default';
import SensorListHeader from './components/SensorListHeader';
import SystemMetricsBar from './components/SystemMetricsBar';
import SensorTable from './components/SensorTable';
import InfoAlertBanner from './components/InfoAlertBanner';

export default function SensorList() {
  return (
      <DefaultLayout>
        <SensorListHeader />
        <SystemMetricsBar />
        <SensorTable />
        <InfoAlertBanner />
      </DefaultLayout>
  )
}